import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { CoverComponent } from './account/auth/signup/cover/cover.component';

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		loadChildren: () =>
			import('./views/views.module').then((m) => m.ViewsModule),
		canActivate: [AuthGuard],
	},
	{
		path: 'auth',
		loadChildren: () =>
			import('./account/account.module').then((m) => m.AccountModule),
	},
	{
        path: 'auth2/signup/cover/:email',
        component: CoverComponent,
    },


];

@NgModule({
	imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
